<template>
    <div class="start-ups-feature-wrap">
        <div class="modern-grid">
            <div v-for="iconbox in iconboxs" :key="iconbox.id" class="ht-box-icon style-02 wow move-up">
                <a :href="iconbox.doclink" class="link-secret">
                    <div class="icon-box-wrap">
                        <div class="icon react" :class="{'react':iconbox.react,'java':iconbox.java, 'macos':iconbox.macos, 'window':iconbox.window,}">
                            <i :class="iconbox.icon"></i>
                        </div>
                        <div class="content">
                            <h6 class="heading">{{ iconbox.heading }}</h6>
                            <h6 class="heading">{{ iconbox.heading2 }}</h6>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'StartUpFeature',
        data (){
          let docslink = process.env.VUE_APP_DOCS_CODEPERF_IO_URL;
            return {
                iconboxs: [
                    {
                        icon: 'fab fa-golang',
                        heading: 'Golang',
                        doclink: docslink+"/getting-started/go",
                      react:true,
                    },
                    {
                        icon: 'fab fa-python',
                        heading: 'Python',
                        heading2: '[SOON]',
                        doclink: docslink+"/getting-started/python",
                        window:true
                    },
                    {
                        icon: 'fab fa-java', 
                        heading: 'Java',
                        heading2: '[SOON]',
                        doclink: docslink+"/getting-started/java",
                        java:true
                    },
                    {
                        icon: 'fab fa-js',
                        heading: 'Javascript',
                        heading2: '[SOON]',
                        doclink: docslink+"/getting-started/js",
                        android:true
                    },
                ]
            }
        }
    }
</script>
